export function Community1() {
  return (
    <div>
      <iframe
        title="Community1 Concept Slides"
        src="https://docs.google.com/presentation/d/e/2PACX-1vTE2GsymcE-E-vRE8r3ai4hHuzj6LEpHxcji2uV64DTP5dRe7Gi4vAln8HdEWyvwrWYiuzE-LLj2NTD/embed?start=false&loop=false"
        width="950"
        height="569"
        allowFullScreen={true}
      ></iframe>
    </div>
  );
}
